import { graphql } from '@/gql';
import type { OptOutOfFreeTrialMutation } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export type OptOutOfFreeTrialOutput = OptOutOfFreeTrialMutation['optOutOfFreeTrial'];

export const optOutOfFreeTrial = async (callerId: string): Promise<OptOutOfFreeTrialOutput> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation OptOutOfFreeTrial($callerId: String!) {
        optOutOfFreeTrial(callerId: $callerId)
      }
    `),
    variables: {
      callerId,
    },
  });

  return response.data!.optOutOfFreeTrial;
};
